module.exports = __webpack_public_path__ + "img/shangrao.609d22db.jpg";